// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application";

// Jobs
import JobTransactionController from "./jobs/job_transaction_controller";
application.register("job-transaction", JobTransactionController);

import JobAnnouncementFormController from "./jobs/job_announcement_form_controller.js"
application.register("job-announcement-form", JobAnnouncementFormController)

import LeadJobModalController from "./jobs/lead_job_modal_controller"
application.register("lead-job-modal", LeadJobModalController)

// Components
import ButtonController from "./components/button_controller"
application.register("button", ButtonController)

import CardSelectorController from "./components/card_selector_controller"
application.register("card-selector", CardSelectorController);

import DropdownController from "./components/dropdown_controller"
application.register("dropdown", DropdownController)

import ImagePreviewController from "./components/image_preview_controller"
application.register("image-preview", ImagePreviewController)

import LottieController from "./components/lottie_controller"
application.register("lottie", LottieController)

import ModalController from "./components/modal_controller"
application.register("modal", ModalController)

// Forms
import ActiveStorageUploadController from "./forms/active_storage_upload_controller"
application.register("active-storage-upload", ActiveStorageUploadController)

import AutoSubmitFormController from "./forms/auto_submit_form_controller"
application.register("auto-submit-form", AutoSubmitFormController)

import InvitationFormController from "./forms/invitation_form_controller"
application.register("invitation-form", InvitationFormController)

import InvoiceProductCalculatorController from "./forms/invoice_product_calculator_controller"
application.register("invoice-product-calculator", InvoiceProductCalculatorController)

import LogoFetcherController from "./forms/logo_fetcher_controller"
application.register("logo-fetcher", LogoFetcherController)

import CheckboxDisableControlsController from "./forms/checkbox_disable_controls_controller"
application.register("checkbox-disable-controls", CheckboxDisableControlsController)

import PhoneNumberController from "./forms/phone_number_controller"
application.register("phone-number", PhoneNumberController)

import ChoicesController from "./forms/choices_controller"
application.register("choices", ChoicesController)

import RecipientPickerController from "./forms/recipient_picker_controller"
application.register("recipient-picker", RecipientPickerController)

import CollapsibleController from "./forms/collapsible_controller"
application.register("collapsible", CollapsibleController)

// Tables
import IndexSelectableController from "./tables/index_selectable_controller"
application.register("index-selectable", IndexSelectableController)

import SortableTableController from "./tables/sortable_table_controller";
application.register("sortable-table", SortableTableController);

// Shared
import FileNameCategorySelectorController from "./shared/file_name_category_selector_controller"
application.register("file-name-category-selector", FileNameCategorySelectorController)

import NavUpgradeController from "./shared/nav_upgrade_controller";
application.register("nav-upgrade", NavUpgradeController);

import SearchController from "./shared/search_controller";
application.register("search", SearchController);

import MapController from "./shared/map_controller";
application.register("map", MapController);
